import { ChangeDetectionStrategy, Component, Inject, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SoModalLayoutUI, SoTableHeader, SoTableUI } from 'so-components-kit';
import { SharedModule } from '@shared/shared.module';
import { TranslateService } from '@core/api/translate.service';
import { GetWsSyncLogsUseCase } from '../../domain/use-cases/get-ws-sync-logs.use-case';
import { WsSyncLog, WsSyncLogsQuery } from '../../domain/interfaces/ws-sync-log.types';

export interface WsSyncLogsModalData {
  idMarca: string;
  idSubmarca: string;
  submarcaName?: string;
}

@Component({
  selector: 'app-ws-sync-logs-modal',
  standalone: true,
  imports: [CommonModule, SharedModule, SoModalLayoutUI, SoTableUI],
  templateUrl: './ws-sync-logs-modal.component.html',
  styleUrl: './ws-sync-logs-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WsSyncLogsModalComponent implements OnInit {
  private readonly getWsSyncLogsUseCase = inject(GetWsSyncLogsUseCase);
  private readonly translateService = inject(TranslateService);
  private readonly dialogRef = inject(MatDialogRef<WsSyncLogsModalComponent>);

  public readonly logs = signal<WsSyncLog[]>([]);
  public readonly loading = signal<boolean>(false);

  public readonly tableHeaders: SoTableHeader[] = [
    { header: this.translateService.instant('date', 'Fecha'), dataName: 'fecha', isDate: true, showHours: true, columnWidth: '20%' },
    { header: this.translateService.instant('action', 'Acción'), dataName: 'accion', columnWidth: '25%', convertFunction: (value: string) => this.humanize(value) },
    { header: this.translateService.instant('status', 'Estatus'), dataName: 'estatus', columnWidth: '15%', convertFunction: (value: string) => this.humanize(value) },
    { header: this.translateService.instant('message', 'Mensaje'), dataName: 'mensaje', columnWidth: '40%' },
  ];

  constructor(@Inject(MAT_DIALOG_DATA) public data: WsSyncLogsModalData) {}

  ngOnInit(): void {
    this.loadLogs();
  }

  private loadLogs(): void {
    const query: WsSyncLogsQuery = {
      idMarca: this.data.idMarca,
      idSubmarca: this.data.idSubmarca,
    };
    this.loading.set(true);
    this.getWsSyncLogsUseCase.execute(query).subscribe({
      next: (items) => {
        this.logs.set(items);
        this.loading.set(false);
      },
      error: () => {
        this.logs.set([]);
        this.loading.set(false);
      },
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  private humanize(value: string): string {
    if (!value) return '';
    const normalized = value.replace(/_/g, ' ').toLowerCase();
    return normalized.charAt(0).toUpperCase() + normalized.slice(1);
  }
}
